import React, { Fragment, ReactElement } from 'react';

import { ButtonGroupWrapper, ButtonSpan } from './styles';
import i18n from '../../i18n';

interface IComponentProps {
  items: {
    [key: string]:
      | string
      | number
      | ReactElement
      | { disabled?: boolean; value: string | ReactElement };
  };
  onSelect: (itemKey: string) => void;
  selected: string;
  vertical?: boolean;
  width?: string;
  custom?: 'number' | 'text';
  columnsNumber?: number;
  style?: React.CSSProperties;
  gap?: string;
  customApplyOnEnter?: boolean;
  colors?: {
    selectedBackgroundColor?: string;
    backgroundColor?: string;
    selectedTextColor?: string;
    textColor?: string;
  };
  border?: boolean;
}

class ButtonGroup extends React.PureComponent<IComponentProps> {
  state = {
    custom: false,
  };

  handleClickOnItem = (itemKey: string) => (e: Event) => {
    if (Object.keys(this.props.items).includes(itemKey)) {
      this.setState({ custom: false });
    }
    this.props.onSelect(itemKey);
    e.preventDefault();
    e.stopPropagation();
  };

  handleClickOnCustomButton = () => {
    if (!this.state.custom) {
      this.setState({ custom: true });
      if (!this.props.customApplyOnEnter) this.props.onSelect('0');
    }
  };

  handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    this.props.onSelect(value);
  };

  render() {
    const {
      items,
      selected,
      custom,
      width,
      columnsNumber,
      style,
      customApplyOnEnter,
      gap,
      vertical,
      colors,
      border = true,
    } = this.props;
    let found = false;
    return (
      <ButtonGroupWrapper
        style={{ ...style, flexDirection: vertical ? 'column' : 'row' }}
        width={width}
        {...colors}
        border={border}
      >
        {Object.entries(items).map((item, index, items) => {
          const active = !this.state.custom && selected === item[0];
          found = found || active;
          const disabled = item[1]?.['disabled'];
          return (
            <Fragment key={item[0]}>
              <ButtonSpan
                {...colors}
                key={item[0]}
                isActive={active}
                aria-disabled={disabled}
                disabled={disabled}
                onClick={
                  !disabled
                    ? this.handleClickOnItem(item[0])
                    : ((() => {
                        /*do nothing*/
                      }) as any)
                }
                flexBasis={
                  columnsNumber ? (1 / columnsNumber) * 100 : undefined
                }
                style={{
                  paddingLeft: gap,
                  paddingRight: gap,
                }}
                border={border}
              >
                {item[1]?.['value'] || item[1]}
              </ButtonSpan>

              {!vertical && (index !== items.length - 1 || custom) ? (
                <span />
              ) : (
                // <span
                //   style={{
                //     width: '1px ',
                //     background: lightGray,
                //     // height: '20px',
                //     marginTop: '8px',
                //     marginBottom: '8px',
                //   }}
                // />
                <></>
              )}
            </Fragment>
          );
        })}
        {custom && (
          <ButtonSpan
            isActive={this.state.custom || !found}
            onClick={this.handleClickOnCustomButton}
            withoutPadding={this.state.custom || !found}
            flexBasis={columnsNumber ? (1 / columnsNumber) * 100 : undefined}
          >
            {!(this.state.custom || !found) ? (
              (i18n.t('custom', { ns: 'survey' }) as string)
            ) : (
              <input
                type={custom}
                value={customApplyOnEnter ? undefined : selected}
                defaultValue={selected}
                onChange={(e) => {
                  if (!customApplyOnEnter) this.handleChangeInput(e);
                }}
                onKeyDown={(event: any) => {
                  if (event.keyCode === 13) {
                    const value = (event.target as HTMLInputElement).value;
                    this.props.onSelect(value);
                  }
                }}
                min="0"
              />
            )}
          </ButtonSpan>
        )}
      </ButtonGroupWrapper>
    );
  }
}

export default ButtonGroup;
